/* global EventSource */
import { React, connect, fetchApi } from '@gasbuddy/react';
import { Dimmer, Loader, Select, Segment, Button, Form, Divider } from 'semantic-ui-react';
import { ActionGroups } from '../../roles';
import { Auth, Nav } from '../../components';

class BaseBulkRerun extends React.Component {
  state = {
    type: 'numeric',
  }

  componentWillUnmount() {
    if (this.sse) {
      this.sse.close();
      delete this.sse;
    }
  }

  go = (e) => {
    e.preventDefault();
    const { inputs, type } = this.state;
    this.setState({ loading: true, running: true, outputs: '' }, async () => {
      const { body: { id } } = await fetchApi({
        url: '/payments/transactions/rerun',
        body: { inputs, type },
      });
      if (this.sse) {
        this.sse.close();
      }
      let outputs = [];
      this.sse = new EventSource(
        `/payments/transactions/stream/${id}`,
        { withCredentials: true },
      );
      this.sse.onmessage = (sseData) => {
        const data = JSON.parse(sseData.data);
        if (data.length === 0) {
          this.sse.close();
          delete this.sse;
          this.setState({ loading: false, running: false });
        }
        outputs = [...outputs, ...data];
        this.setState({ loading: false, outputs: outputs.join('\n') });
      };
    });
  }

  render() {
    const { inputs, type, outputs, loading, running } = this.state;
    return (
      <Auth
        forActions={ActionGroups.Users}
      >
        <Nav>
          <Dimmer.Dimmable as={Segment} dimmed={loading}>
            <Dimmer active={loading}>
              <Loader />
            </Dimmer>
            <div>
              <h1>Re-Run Transactions</h1>
              <Form onSubmit={this.go}>
                <Form.Group>
                  <Select
                    style={{ minWidth: 300 }}
                    options={[{ text: 'Numeric Transaction IDs', value: 'numeric' }, { text: 'Encrypted Transaction IDs', value: 'encrypted' }]}
                    placeholder="Select input format"
                    value={type}
                    onChange={(e, selection) => this.setState({ type: selection.value })}
                  />
                  &nbsp;
                  <Button loading={loading || running}>Go</Button>
                </Form.Group>
                <Divider />
                <Form.Group widths="equal">
                  <Form.TextArea
                    rows={30}
                    value={inputs}
                    onChange={e => this.setState({ inputs: e.target.value })}
                    label="Input values"
                    placeholder="One per line, or csv, or any whitespace between ids"
                  />
                  <Form.TextArea
                    rows={30}
                    readOnly
                    value={outputs}
                    label="Results"
                    placeholder="Results will appear here"
                  />
                </Form.Group>
              </Form>
            </div>
          </Dimmer.Dimmable>
        </Nav>
      </Auth>
    );
  }
}

export const BulkRerun = connect(({ api }) => ({ api }))(BaseBulkRerun);
